import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetRecruitingStatusesMutation } from '../apis';
import type { RecruitingStatusQueryLinkerSchema } from '../schemas';

export function RecruitingStatusesSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<RecruitingStatusQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: RecruitingStatusQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/recruiting-statuses/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetRecruitingStatusesMutation}
      disabled={disabled}
    />
  );
}
